import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { DrawingBomContext } from "../../DrawingBomContext";
import { groupingPlatesTableCols } from "./cols";
import {
  bulkDescriptionMrqMaterialsCols,
  bulkDescriptionMrqMaterialsColsEdit,
  taggedMrqMaterialsCols,
} from "../../../Components/cols/mrqMaterialsCols";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function GroupingTable() {
  const {
    consolidatedMaterials,
    consolidatedMaterialsData,
    consolidatedTaggedMaterialsData,
    mrqMaterials,
    setMrqMaterials,
  } = React.useContext(DrawingBomContext);

  const isTaggedMaterials = consolidatedMaterials?.[0].tagNumber;
  const isMaterialCodeMaterials = consolidatedMaterials?.[0].materialCode;

  const onChange = (e, row) => {
    e.preventDefault();
    const { name, value } = e.target;
    console.log("edit:", { [name]: value }, row);

    const updatedMaterials = mrqMaterials.map((m) => {
      if (m.id === row.id) {
        return { ...m, [name]: value };
      } else {
        return m;
      }
    });
    setMrqMaterials(updatedMaterials);
  };

  const table = useMaterialReactTable({
    columns: isTaggedMaterials
      ? taggedMrqMaterialsCols
      : isMaterialCodeMaterials
      ? groupingPlatesTableCols
      : bulkDescriptionMrqMaterialsColsEdit(onChange),

    data: isTaggedMaterials
      ? consolidatedTaggedMaterialsData.map((m) => {
          return m.description
            ? m
            : {
                ...m,
                description:
                  m.taggedMaterial?.component + m.taggedMaterial?.size,
              };
        })
      : isMaterialCodeMaterials
      ? consolidatedMaterialsData
      : mrqMaterials,
    enableStickyHeader: true,
    ...lightTable,

    muiTableContainerProps: {
      sx: { maxHeight: isTaggedMaterials ? "350px" : "450px" },
    },
  });

  return <MaterialReactTable table={table} />;
}
